import { initLocale } from '@crm/translator';
import { initContext } from '@crm/transporter';
import { settingNumberConverter } from '@crm/core';

export const initializeData = async () => {
  const context = await initContext({
    bootstrapDomain: window.__ENV__.bootstrapDomain,
    bootstrapDomainRole: window.__ENV__.bootstrapDomainRole,
    syncDataAfterBootstrap: async (bootstrap) => {
      // const languages = bootstrap.supportedLanguages;
      // if (languages?.length === 1) await initLocale(languages[0]);
      // else
      await initLocale();
    },
  });

  settingNumberConverter();

  return context;
};
